import { Typography, TypographyProps } from '@mui/material';

/**
 * Renders a Typography component if children is a string or number, and applies the give props, otherwise renders children directly
 */
export const TypographyOrNode = ({ children, ...props }: TypographyProps) => {
  if (['string', 'number'].includes(typeof children)) {
    return <Typography {...props}>{children}</Typography>;
  }
  return children;
};
